import { Grid } from '@theme-ui/components';

import { isNotNullish } from '@app/helpers/predicate';
import { rem } from '@app/styles/theme/layout';

import { LicenseCard } from '../LicenseCard/LicenseCard';
import { LicenseCardVariant } from '../LicenseCard/LicenseCard.constants';
import type { LicenseCardGridProps } from '../LicenseSelector';

const LicenseCardsGrid = ({
  hasBestOption,
  variantLicenses,
  getCardVariant,
  selectedVariant,
  setSelectedVariant,
}: LicenseCardGridProps) => {
  return (
    <Grid
      sx={{
        gridRowGap: [hasBestOption ? rem(10) : rem(40), rem(40)],
        gridColumnGap: 2,
        gridTemplateColumns: [
          '1',
          'repeat(2, 1fr)',
          `repeat(auto-fill, minmax(${rem(170)}, 1fr) )`,
        ],
        mb: [4, hasBestOption ? 5 : 4, rem(30)],
      }}
    >
      {variantLicenses?.map((variant) => {
        if (isNotNullish(variant)) {
          const cardVariant = getCardVariant(variant);

          return (
            <LicenseCard
              variant={cardVariant}
              isSelected={
                variant?.product?.uid === selectedVariant?.product?.uid
              }
              key={variant?.product?.uid}
              productVariant={variant}
              onClick={(e) => {
                e.preventDefault();
                setSelectedVariant(variant);
              }}
              sx={{
                mb: [
                  cardVariant === LicenseCardVariant.Recommendation
                    ? rem(33)
                    : 0,
                  0,
                ],
              }}
            />
          );
        }
      })}
    </Grid>
  );
};

export default LicenseCardsGrid;
